import { DoctorLayout } from "@/components/layout/doctor-layout";
import { DictationWorkspace } from "@/pages/shared/dictation";

export default function DoctorDictation() {
  return (
    <DoctorLayout title="Consultation Note Dictation">
      <DictationWorkspace
        audience="doctor"
        accentClass="bg-gradient-to-br from-indigo-700 to-indigo-900 text-white"
        primaryBtnClass="bg-indigo-700 hover:bg-indigo-800"
        title="Dictate a consultation note"
        subtitle="Speak freely — Whisper transcribes and GPT structures the draft for you to review and sign."
      />
    </DoctorLayout>
  );
}
